module.exports={
	"Scope": "ContractType-List",
	"CoreEntity": "ContractType",
	"TitleTemplate": "Contract Types",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ContractTypeListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "ContractTypeListHash",
			"PictDashboard": {}
		},
		"Description":
		{
			"Name": "Description",
			"Hash": "ContractTypeListDescription",
			"PictDashboard": {}
		}
	}
}
